
<template>
    <v-card class="ma-2" elevation="2" style="border-radius: 16px;">
        <v-card-text style="display: flex; flex-direction: column; align-items: center;">
            <h2 class="text-h6 font-weight-bold mb-5">{{ getTitle }}</h2>

            <!-- ===== Cartões salvos (cofre) ===== -->
            <div v-if="!addCard && hasCards" style="width: 100%; max-width: 460px;">
                <v-card
                    v-for="card in userCards"
                    :key="card.id"
                    class="mb-3"
                    :elevation="isSelected(card) ? 6 : 1"
                    :style="`border-radius: 12px; border: 2px solid ${isSelected(card) ? $theme.primary : 'transparent'};`"
                    @click="onCardSelect(card)"
                >
                    <v-card-text class="d-flex align-center" style="gap: 10px;">
                        <v-icon :color="isSelected(card) ? 'primary' : 'grey lighten-1'">
                            {{ isSelected(card) ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                        </v-icon>
                        <v-img
                            height="22"
                            max-width="44"
                            contain
                            :src="card.payment_method.secure_thumbnail"
                        />
                        <div class="text-left" style="flex: 1; min-width: 0;">
                            <div class="font-weight-bold">•••• {{ card.last_four_digits }}</div>
                            <div class="text-caption grey--text text-uppercase text-truncate">
                                {{ card.cardholder.name }}
                            </div>
                        </div>
                        <v-chip v-if="isDefault(card)" x-small color="primary" outlined>padrão</v-chip>
                        <v-menu offset-y>
                            <template #activator="{ on }">
                                <v-btn icon small v-on="on" @click.stop>
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item v-if="!isDefault(card)" @click="definirPadrao(card)">
                                    <v-list-item-title>Tornar padrão</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="excluirCartao(card)">
                                    <v-list-item-title class="red--text">Excluir</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-card-text>

                    <!-- CVV do cartão selecionado -->
                    <v-card-text v-if="isSelected(card)" class="pt-0">
                        <v-text-field
                            v-model="savedCardCvv"
                            label="CVV do cartão"
                            type="tel"
                            v-mask="['#####']"
                            outlined
                            dense
                            hide-details
                            style="max-width: 180px;"
                            @click.stop
                        />
                    </v-card-text>
                </v-card>

                <!-- Confirmar CPF/e-mail quando não temos no cadastro (ex.: device novo).
                     MP exige e-mail + CPF do pagador também no cartão salvo. -->
                <v-expand-transition>
                    <div v-if="confirmarDados">
                        <v-row dense class="mt-1">
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    label="CPF do Titular"
                                    type="tel"
                                    v-model="card.cpf"
                                    v-mask="['###.###.###-##']"
                                    :rules="[rules.empty, rules.cpf]"
                                    outlined
                                    dense
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    label="E-mail"
                                    type="email"
                                    v-model="card.email"
                                    :rules="[rules.empty, rules.email]"
                                    outlined
                                    dense
                                    hide-details="auto"
                                />
                            </v-col>
                        </v-row>
                    </div>
                </v-expand-transition>

                <v-btn text color="primary" class="text-none mt-1" @click="addCard = true">
                    <v-icon left>mdi-plus</v-icon> Adicionar outro cartão
                </v-btn>
            </div>

            <!-- ===== Formulário de novo cartão ===== -->
            <v-card v-if="addCard || !hasCards" width="600" max-width="100%" class="ma-2" flat>
                <v-card-text>
                    <v-form ref="form">
                        <v-row v-if="hasCards">
                            <v-col class="py-0">
                                <v-btn icon @click="addCard = false">
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <div style="display: flex; align-items: center;" class="mt-2">
                                    <div style="font-size: 12px; text-align: left; font-weight: bold; line-height: 15px;">
                                        Cartões Aceitos:
                                    </div>
                                    <v-img
                                        v-for="brand in ['mastercard', 'visa', 'elo', 'amex', 'hipercard']"
                                        :key="brand"
                                        height="15"
                                        width="40"
                                        contain
                                        :src="require(`@/assets/${brand}.png`)"
                                    />
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    label="Titular do Cartão"
                                    v-model="card.name"
                                    :rules="[rules.empty]"
                                    outlined
                                    dense
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    label="CPF do Titular"
                                    type="tel"
                                    v-model="card.cpf"
                                    v-mask="['###.###.###-##']"
                                    :rules="[rules.empty, rules.cpf]"
                                    outlined
                                    dense
                                    hide-details="auto"
                                />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    label="E-mail"
                                    type="email"
                                    v-model="card.email"
                                    :rules="[rules.empty, rules.email]"
                                    outlined
                                    dense
                                    hide-details="auto"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field
                                    label="Número do Cartão"
                                    type="tel"
                                    v-model="card.number"
                                    v-mask="[cardMask]"
                                    :rules="[rules.empty]"
                                    outlined
                                    dense
                                    hide-details
                                />
                                <v-alert
                                    v-if="ehDebito"
                                    dense
                                    text
                                    type="info"
                                    class="mt-2 mb-0"
                                    style="font-size: 12px;"
                                >
                                    Cartão de débito: você confirmará a compra no seu banco (autenticação).
                                </v-alert>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6">
                                Validade do Cartão
                                <div style="display: flex;">
                                    <v-select
                                        v-model="card.expirationMonth"
                                        :items="months"
                                        label="Mês"
                                        :rules="[rules.empty]"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                    <v-select
                                        v-model="card.expirationYear"
                                        :items="years"
                                        label="Ano"
                                        :rules="[rules.empty]"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6" style="display: flex; align-items: flex-end;">
                                <v-text-field
                                    v-model="card.cvv"
                                    label="CVV"
                                    type="tel"
                                    :rules="[rules.empty]"
                                    v-mask="['#####']"
                                    outlined
                                    dense
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row v-if="isLoggedIn">
                            <v-col class="pb-0">
                                <v-checkbox
                                    v-model="saveCard"
                                    label="Salvar cartão para os próximos pedidos"
                                    dense
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col style="display: flex; align-items: center;">
                                <v-img
                                    :src="require('@/assets/mercadopago-hands.png')"
                                    height="25"
                                    width="25"
                                    contain
                                    class="mr-2"
                                />
                                <div style="font-size: 12px; text-align: left; width: 95%;">
                                    Pagamento protegido por Mercado Pago.
                                </div>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>

            <v-btn
                x-large
                color="primary"
                block
                rounded
                class="white--text mt-6 text-none"
                :loading="cardPaymentLoading"
                @click="pagar"
            >Pagar {{ formatMoney(value.total) }}</v-btn>

        </v-card-text>
    </v-card>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { installMercadoPago, getPaymentToken, getPaymentMethod } from '@/plugins/mercadoPago';

export default {
    name: 'CartaoCredito',

    data: () => ({
        addCard: false,
        saveCard: true,
        confirmarDados: false,
        selectedCardId: null,
        savedCardCvv: '',
        detectedMethod: null, // { id, type } resolvido pelo MP via BIN (autoritativo)
        binDebounce: null,
        months: [],
        years: [],
        card: { name: '', cpf: '', email: '', number: '', expirationMonth: '', expirationYear: '', cvv: '' },
        rules: {
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'E-mail inválido'
            },

            empty: value => !!value || 'Preenchimento obrigatório',

            fullName: value => (value || '').trim().split(' ').length > 1 || 'Informe o nome completo',

            cpf: value => value?.length == 14 || 'Cpf incompleto',
        },
    }),

    props: ['value'],

    mounted() {
        installMercadoPago();

        this.fillOptions();
        this.loadPayerData();
        this.preselectCard(this.usuario.cards);
    },

    watch: {
        'usuario.cards'(cards) {
            this.preselectCard(cards);
        },

        // Resolve a bandeira/método pelo BIN no MP (débito vs crédito confiável).
        'card.number'(val) {
            const num = (val || '').replace(/\D/g, '');
            clearTimeout(this.binDebounce);
            if (num.length < 6) {
                this.detectedMethod = null;
                return;
            }
            this.binDebounce = setTimeout(async () => {
                this.detectedMethod = await getPaymentMethod(num.slice(0, 8));
            }, 400);
        },
    },

    computed: {
        ...mapState([
            'usuario',
            'cliente',
            'cardPaymentLoading',
        ]),

        isLoggedIn() {
            return !!this.usuario?.id;
        },

        cardType() {
            // Preferir o método autoritativo do MP (via BIN); regex é só fallback.
            if (this.detectedMethod && this.detectedMethod.id) {
                return this.detectedMethod.id;
            }

            const number = (this.card.number || '').replace(/\s/g, '');

            if (number.match(new RegExp('^(410390|410391|410392|485464|452204|409869|496046)')) != null) {
                return 'debvisa';
            }

            if (number.match(new RegExp('^(4|46348800)')) != null) {
                return 'visa';
            }

            if (number.match(new RegExp('^(34|37)')) != null) {
                return 'amex';
            }

            if (number.match(new RegExp('^(532884)')) != null) {
                return 'master';
            }

            // Mastercard: tradicional (51–55), nova faixa 2-série (2221–2720) e o cartão de teste do MP (5031)
            if (number.match(new RegExp('^(5[1-5]|5031|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)')) != null) {
                return 'master';
            }

            if (number.match(new RegExp('^(502121|536106)')) != null) {
                return 'debmaster';
            }

            if (number.match(new RegExp('^(523431)')) != null) {
                return 'maestro';
            }

            if (number.match(new RegExp('^(506722)')) != null) {
                return 'debelo';
            }

            if (number.match(new RegExp('^((606282)|(637095)|(637568)|(637599)|(637609)|(637612))')) != null) {
                return 'hipercard ';
            }

            return ''; // default type
        },

        cardMask() {
            return this.cardType === 'amex'
                ? '#### ###### #####'
                : '#### #### #### ####';
        },

        ehDebito() {
            // Tipo autoritativo do MP quando disponível; senão cai no id por bandeira.
            if (this.detectedMethod && this.detectedMethod.type) {
                return this.detectedMethod.type === 'debit_card';
            }
            return ['debvisa', 'debmaster', 'debelo', 'maestro'].includes(this.cardType);
        },

        userCards() {
            return this.usuario.cards || [];
        },

        hasCards() {
            return this.usuario.cards?.length;
        },

        getTitle() {
            return this.hasCards ? 'Como será o pagamento?' : 'Informe seus Dados de Pagamento';
        },
    },

    methods: {
        ...mapMutations({
            setCardPaymentLoading: 'setCardPaymentLoading',
        }),

        fillOptions() {
            this.months = [
                '01', '02', '03', '04', '05', '06',
                '07', '08', '09', '10', '11', '12',
            ];
            const year = new Date().getFullYear();
            for (let i = 0; i < 10; i++) {
                this.years.push((year + i).toString());
            }
        },

        loadPayerData() {
            try {
                const saved = JSON.parse(localStorage.getItem('zaperPayerData') || '{}');
                this.card.cpf = saved.cpf || this.card.cpf;
                this.card.email = saved.email || this.card.email;
            } catch (e) { /* ignora dados inválidos */ }
        },

        savePayerData() {
            localStorage.setItem('zaperPayerData', JSON.stringify({
                cpf: this.card.cpf || '',
                email: this.card.email || '',
            }));
        },

        preselectCard(cards) {
            if (!cards || !cards.length) {
                return;
            }

            const padrao = this.usuario.default_card_id;
            this.selectedCardId = (padrao && cards.some(c => c.id === padrao))
                ? padrao
                : cards[0].id;
        },

        isSelected(card) {
            return card.id === this.selectedCardId;
        },

        isDefault(card) {
            return this.usuario.default_card_id && card.id === this.usuario.default_card_id;
        },

        onCardSelect(card) {
            this.selectedCardId = card.id;
            this.savedCardCvv = '';
        },

        getCardId() {
            return this.selectedCardId;
        },

        async definirPadrao(card) {
            await this.$http.post(`account/cards/${card.id}/default`).then(resp => {
                if (resp.data.type !== 'success') {
                    this.notify(resp.data.msg || 'Não foi possível definir o padrão', 'warning');
                    return;
                }
                this.usuario.default_card_id = card.id;
                this.notify('Cartão padrão definido');
            }).catch(() => this.notify('Não foi possível concluir a operação', 'warning'));
        },

        async excluirCartao(card) {
            const ok = await this.$root.$confirm('Excluir cartão', 'Remover este cartão salvo?', { color: 'red darken-1' });
            if (!ok) {
                return;
            }

            await this.$http.delete(`account/cards/${card.id}`).then(resp => {
                if (resp.data.type !== 'success') {
                    this.notify(resp.data.msg || 'Não foi possível excluir', 'warning');
                    return;
                }
                this.usuario.cards = (this.usuario.cards || []).filter(c => c.id !== card.id);
                if (this.selectedCardId === card.id) {
                    this.preselectCard(this.usuario.cards);
                }
                this.notify('Cartão removido');
            }).catch(() => this.notify('Não foi possível concluir a operação', 'warning'));
        },

        async pagar() {
            const usandoCartaoSalvo = !this.addCard && this.hasCards;
            const customerId = usandoCartaoSalvo ? (this.usuario?.mercado_pago_customer_id || '') : '';

            if (usandoCartaoSalvo) {
                if (!this.getCardId()) {
                    this.notify('Selecione um cartão', 'warning');
                    return;
                }
                if (!this.savedCardCvv) {
                    this.notify('Digite o CVV do cartão', 'warning');
                    return;
                }
            } else {
                if (!this.$refs.form.validate()) {
                    this.notify('Preencha todos os campos', 'warning');
                    return;
                }
                if (!this.cardType) {
                    this.notify('Desculpe, ainda não aceitamos a bandeira do seu cartão', 'warning');
                    return;
                }
            }

            // Dados do pagador. No cartão NOVO o MP exige e-mail + CPF: puxamos do
            // cadastro logado e, se faltar/for inválido (ex.: device novo), revelamos
            // os campos pra confirmar — nunca enviamos vazio (senão dá "Params Error").
            // No cartão SALVO pagamos via customer (payer.type=customer); o MP usa os
            // dados do customer, então CPF/e-mail não são necessários.
            const payerEmail = (this.card.email || this.cliente?.email || '').trim();
            const payerCpf = (this.card.cpf || this.cliente?.cpf_cnpj || '').toString();

            if (!customerId) {
                const emailValido = this.rules.email(payerEmail) === true;
                const cpfValido = payerCpf.replace(/\D/g, '').length >= 11;

                if (!emailValido || !cpfValido) {
                    this.card.email = payerEmail;
                    if (!cpfValido) {
                        this.card.cpf = '';
                    }
                    this.confirmarDados = true;
                    this.notify('Confirme seu CPF e e-mail para concluir o pagamento', 'warning');
                    return;
                }
            }

            const cardSalvo = usandoCartaoSalvo
                ? (this.usuario.cards || []).find(c => c.id === this.selectedCardId)
                : null;

            const card = usandoCartaoSalvo
                ? {
                    cardId: this.selectedCardId,
                    securityCode: this.savedCardCvv,
                }
                : {
                    cardholderName: this.card.name,
                    cardNumber: this.card.number?.replace(/\s/g, ''),
                    cardExpirationMonth: this.card.expirationMonth,
                    cardExpirationYear: this.card.expirationYear,
                    securityCode: this.card.cvv,
                };

            if (!usandoCartaoSalvo) {
                this.savePayerData();
            }

            this.setCardPaymentLoading(true);

            await getPaymentToken(card).then(token => {
                this.$emit('pay', {
                    token,
                    cardType: usandoCartaoSalvo ? (cardSalvo?.payment_method?.id || '') : this.cardType,
                    email: payerEmail,
                    cpf: payerCpf,
                    customerId,
                    issuerId: usandoCartaoSalvo ? (cardSalvo?.issuer?.id || '') : '',
                    salvar: !usandoCartaoSalvo && this.isLoggedIn && this.saveCard,
                });
            })
            .catch(e => {
                this.notify('Não foi possível processar o cartão. Confira os dados e tente novamente.', 'warning');
                this.setCardPaymentLoading(false);
                console.log(e);
            });
        },
    },
}
</script>

<style scoped>
::v-deep .v-label {
    font-size: 14px;
}
</style>
